<template>
    <div class="about-mav">
        <p class="indent">Alcomet’s mission is to be a socially responsible and resource-efficient company offering innovative solutions to our customers and providing opportunities to our partners.</p>
        <p class="indent">The core values that define us as a company are:</p>
        <div class="values-wrapper">
          <div class="value">
            <h3 class="strong">Loyalty</h3>
            <p>Being a reliable partner to the customers who have placed their trust in us, offering them the best possible service and providing support to their development.</p>
          </div>
          <div class="value">
            <h3 class="strong">Responsibility</h3>
            <p>In our attitude towards the local community and the environment, our stakeholders and our partners.</p>
          </div>
          <div class="value">
            <h3 class="strong">Flexibility</h3>
            <p>In our ability to adapt to the dynamic market conditions and ever changing needs of our clients.</p>
          </div>
          <div class="value">
            <h3 class="strong">Transparency</h3>
            <p>In our actions, our business strategy and corporate policy, by meeting the highest standards of honesty and professionalism.</p>
          </div>
        </div>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-mav p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.values-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: 30px auto 0;
  width: 1000px;
}
.value {
  align-items: center;
  border-radius: 6px;
  background-color: #008bc2;
  display: flex;
  padding: 20px;
  flex-direction: column;
  margin: 15px 0;
  width: calc(50% - 15px);
}
.value:nth-child(odd) {
  margin-right: 30px;
}
.value:nth-child(3),
.value:nth-child(4) {
  margin-bottom: 0;
}
.value h3 {
  color: #fff;
  font-size: 24px;
  text-align: center;
  margin: 15px 0;
}
.value > p {
  color: #fff;
  margin: 0;
  padding: 15px;
  width: 100%;
}
@media screen and (max-width: 1440px) {
  .values-wrapper {
    width: 800px;
  }
}
@media screen and (max-width: 1280px) {
  .values-wrapper {
    width: 80%;
  }
}
@media screen and (max-width: 1000px) {
  .about-mav p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .values-wrapper {
    width: 100%;
    padding: 0 30px;
  }
  .value {
    padding: 20px;
  }
  .value h3 {
    font-size: 20px;
    margin-top: 0;
  }
  .value p {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    padding: 0;
  }
}
@media screen and (max-width: 800px) {
  .value p {
    font-size: 14px;
    line-height: 20px;
  }
}
@media screen and (max-width: 600px) {
  .about-mav .value {
    width: 100%;
    margin: 10px 0;
  }
  .about-mav .value:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/MissionAndValues.vue